import { useEffect, useRef } from "react";
import useMediaQuery from "../hooks/useMediaQuery";
import SocialMediaIcons from "../components/SocialMediaIcons";
// The animated logo used to be a 4 MB GIF, the first and largest download on
// the page. The same animation as an MP4 is about 175 KB.
import LogoVideo from "../assets/optimized/strange-lot-logo.mp4";
// Fallback for browsers built without the MP4 (H.264) codec.
import LogoVideoWebm from "../assets/optimized/strange-lot-logo.webm";
import LogoPoster from "../assets/optimized/strange-lot-logo-poster.webp";

const Landing = ({ setSelectedPage }) => {
  const isAboveMediumScreens = useMediaQuery("(min-width: 1060px)");
  const logoRef = useRef(null);

  // React doesn't reliably write the `muted` attribute to the DOM, and mobile
  // Safari only autoplays videos that are muted, so set it directly.
  useEffect(() => {
    const video = logoRef.current;
    if (!video) return;
    video.muted = true;
    const playing = video.play();
    if (playing) playing.catch(() => {});
  }, []);

  return (
    <div id="home" className="bg-coolDark">
      <div className="flex flex-col md:flex-row items-center md:justify-between max-w-6xl mx-auto px-6 md:px-10 pt-6 pb-1 md:pt-8 md:pb-2 gap-3 md:gap-0">
        <video
          ref={logoRef}
          poster={LogoPoster}
          autoPlay
          muted
          loop
          playsInline
          aria-label="Strange Lot"
          className={`shrink-0 w-auto ${isAboveMediumScreens ? "h-16" : "h-8"}`}
        >
          <source src={LogoVideo} type="video/mp4" />
          <source src={LogoVideoWebm} type="video/webm" />
        </video>
        <h1 className="sr-only">STRANGE LOT</h1>
        <div className="md:scale-150 md:origin-right">
          <SocialMediaIcons />
        </div>
      </div>
    </div>
  );
};

export default Landing;
